import { requests } from '.'
import config from '../config'
interface LocationIdParams {
  locationId: string
  limit: number
  skip?: number
  query?: string
}

interface GetById {
  id: string
}

interface UpdateForm {
  id: string
  name: string
  formData: Object
}

interface CreateForm {
  parentId: string | undefined
  locationId: string
  formData?: object
}
interface FormsList {
  formIds: string
}

interface ExportSubmissionsParams {
  formIds: string[];
  startDate: string;
  endDate: string;
  locationId: string;
  companyId: string;
  type: string;
}

const FormServices = {
  getByLocationId: (params: LocationIdParams) =>
    requests(config.formsApiUrl).get('/forms/', { params }),
  getCountByLocationId: (locationId: string) =>
    requests(config.formsApiUrl).get('/forms/count', { params:{locationId} }),
  getById: (params: GetById) =>
    requests(config.formsApiUrl).get(`/forms/${params.id}`),
  getListByIds:(params: FormsList) =>
    requests(config.formsApiUrl).get(`/forms/forms-list`,{ params }),
  createForm: (params: CreateForm) =>
    requests(config.formsApiUrl).post('/forms/', params),
  updateForm: (params: UpdateForm) =>
    requests(config.formsApiUrl).post(`/forms/${params.id}`, {
      formData: params.formData,
      name: params.name,
    }),
  scheduleExportForm: (params: ExportSubmissionsParams) =>
    requests(config.formsApiUrl).post('/forms/schedule-form-export', params),

    getByLocationIdV1: (locationId: string, internalChannel) => {
      const headers = {
        "location-id": locationId,
        "internal-channel": internalChannel
      }
      return requests(config.formsApiUrlV1, headers).get('/v1/forms')
  }
}

export { FormServices }